import { render, staticRenderFns } from "./crudcampomr.vue?vue&type=template&id=455faace&scoped=true"
import script from "./crudcampomr.vue?vue&type=script&lang=js"
export * from "./crudcampomr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455faace",
  null
  
)

export default component.exports